import { Minus, Plus, X } from "lucide-react";
import { brl, num, parseNum } from "@/lib/format";

function QtyStepper({ item, onQty }) {
  const step = (d) => onQty(String(Math.max(0, Math.round((parseNum(item.qty) + d) * 1000) / 1000)).replace(".", ","));
  const pid = item.product_id;
  return (
    <div className="flex gap-1.5 items-center">
      <button type="button" className="stepper !w-9 !h-9" onClick={() => step(-1)} data-testid={`list-item-minus-${pid}`}><Minus size={14} /></button>
      <input className="input input-sm tnum text-center w-16 sm:w-20" inputMode="decimal" value={item.qty} onFocus={(e) => e.target.select()}
        onChange={(e) => onQty(e.target.value)} data-testid={`list-item-qty-${pid}`} />
      <button type="button" className="stepper !w-9 !h-9" onClick={() => step(1)} data-testid={`list-item-plus-${pid}`}><Plus size={14} /></button>
    </div>
  );
}

export default function SelectedItems({ items, onQty, onRemove, showCost }) {
  const total = items.reduce((a, i) => a + parseNum(i.qty) * (i.unit_cost || 0), 0);
  return (
    <div className="card flex flex-col gap-1" data-testid="selected-items">
      <div className="flex items-center justify-between mb-2">
        <div className="h3">Itens da lista ({items.length})</div>
        {showCost && items.length > 0 && <span className="caption tnum" data-testid="list-estimated-total">Estimado {brl(total)}</span>}
      </div>
      {!items.length && <p className="caption py-3">Nenhum produto na lista. Use “Adicionar produtos” para incluir os itens cadastrados.</p>}
      <div className="divide">
        {items.map((i) => (
          <div key={i.product_id} className="flex flex-wrap items-center gap-x-3 gap-y-2 py-2.5" data-testid={`list-item-${i.product_id}`}>
            <div className="flex-1 min-w-0 basis-[calc(100%-56px)] sm:basis-0 order-1">
              <div className="label truncate">{i.product_name}</div>
              <div className="caption truncate">{i.category_name || "Sem categoria"}{showCost && parseNum(i.qty) > 0 ? ` · ${brl(parseNum(i.qty) * (i.unit_cost || 0))}` : ""}</div>
            </div>
            <div className="order-3 sm:order-2 flex items-center gap-2"><QtyStepper item={i} onQty={(v) => onQty(i.product_id, v)} /><span className="caption w-8">{i.unit}</span></div>
            <button type="button" className="icon-btn order-2 sm:order-3" title="Remover" onClick={() => onRemove(i.product_id)} data-testid={`list-item-remove-${i.product_id}`}><X size={15} /></button>
            {parseNum(i.qty) <= 0 && <span className="caption w-full order-4" style={{ color: "var(--danger)" }}>Informe a quantidade ({num(0)} não entra na lista)</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
